export default "__VITE_ASSET__nG_uuKMX__"